import loadable from '@loadable/component'

const ProjectDetailsRoute = loadable(() => import('./ProjectDetailsRoute'))
const StakingRoute = loadable(() => import('./StakingRoute'))
const HomeRoute = loadable(() => import('./Home'))
const DashboardRoute = loadable(() => import('./DashboardRoute'))

export { ProjectDetailsRoute, StakingRoute, HomeRoute, DashboardRoute }
